import React from 'react';
import PropTypes from 'prop-types';

import DealCell from 'bundles/apex/deals/cell';
import DealValue from 'bundles/apex/deals/value';

export default function Deal({ className, deal, orderedColumns }) {
  return (
    <tr className={className}>
      {orderedColumns.map(({ key }) => (
        <DealCell key={key} name={key}>
          <DealValue deal={deal} name={key} />
        </DealCell>
      ))}
    </tr>
  );
}

Deal.propTypes = {
  className: PropTypes.string,
  deal: PropTypes.object.isRequired,
  orderedColumns: PropTypes.array.isRequired,
};
